import Logo from "./Logo";
import SearchBar from "./SearchBar";
import Upload from "./Upload";
import Button from "./Button";

function Navbar (props){

  const {isMobile}=props
  return(
    isMobile ? (<div id="Navbar" className="mobile container-fluid">Mobile</div>) 
    :
    (<div id="Navbar" className="desktop row col-12">
    <Logo />
    <SearchBar />
    <Upload />
    <Button text={"Log in"} type={"primary"}/>
  </div>)
  );
}



export default Navbar;